import {TYPE_TO_COMPONENT, LFO, PLANAR_SNAPSHOTS, JAKI_PARAMS} from 'constants/pullable-types.js';
export const findEffect = (id, sequencerEngine) => {
    for (let sub of sequencerEngine.subSequences) {
        for (let track of sub.tracks) {
            let effects = [... track.effects, ...track.midiEffects.effects, ...track.liveEffects.effects];
            for (let effect of effects) {
                if (effect.effects) {
                    effects = [... effects, ...effect.effects];
                }
            }
            let effect = effects.find(x => x.id === id);
            if (effect) {
                return effect;
            }
        }
        let fx = sub.midiEffects.effects.find(x => x.id === id);
        if (fx) {
            return fx;
        }
    }
    return undefined;
}

export const findInstrumentPart = (id, type, sequencerEngine) => {
    console.log('findInstrumentPart', id, type, sequencerEngine);
    for (let sub of sequencerEngine.subSequences) {
        if (type === LFO) {
            let lfo = sequencerEngine.lfos.find(
                ({lfo}) => lfo.id === id);
            return {
                type: LFO,
                instrument: lfo,
                effect: lfo,
                id: id
            };
        }
        if (type === "MODULE_ENVELOPE") {
            let envelope = sequencerEngine.envelopes.find(
                (env) => env.id === id);
            if (envelope) {
                return {
                    type: "MODULE_ENVELOPE",
                    instrument: envelope,
                    subType: envelope.number, 
                    id: id
                };
            } else {
                return undefined;
            }
        } 
        for (let track of sub.tracks) {
            if (type === PLANAR_SNAPSHOTS || type === JAKI_PARAMS) {
                let component = TYPE_TO_COMPONENT[type];
                return findSubType(track, component, type, id);
           }
            if (track.instrument && track.instrument.id === id) {
                return {
                    type,
                    track: track,
                    instrument: track.instrument
                };
            }
        }
    }
    return undefined;
};

const findSubType = (track, component, type, id) => {
    // find it
    let midiFx = [];
    for (let fx of track.midiEffects.effects) {
        if (fx.effects) {
            midiFx = [... midiFx, ... fx.effects];
        } else {
            midiFx.push(fx);
        }
    }
    let effectFound = midiFx.find(e => e[component] &&
                                  e[component].id === id);
    if (effectFound) {
        return {
            type,
            track: track,
            instrument: effectFound[component],
            effect: effectFound,
        };
    }
    return undefined;
};
 
